var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentNull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-153.000000, -373.000000) translate(153.000000, 373.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "#F6F9FB",
    rx: 35
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7DCE2",
    fillRule: "nonzero",
    d: "M58.605 23.348l1.121-1.149c.271-.284.41-.59.415-.919.005-.328-.122-.629-.382-.903l-.341-.311c-.239-.252-.523-.367-.853-.345-.33.022-.62.164-.87.427l-1.137 1.116 2.047 2.084zM41.043 39.416l3.054-1.412L57.501 24.48l-2.047-2.067-13.404 13.54-1.462 2.987c-.065.12-.04.246.073.377.114.131.241.164.382.099zm8.156 9.88c1.386 0 2.453-.37 3.2-1.108.748-.739 1.121-1.808 1.121-3.209V32.36l-2.242 2.248V45.06c0 .679-.178 1.199-.536 1.56-.357.36-.866.541-1.527.541H19.094c-.66 0-1.167-.18-1.519-.541-.352-.361-.528-.881-.528-1.56V32.178c0-1.4.682-2.1 2.047-2.1h24.938l2.096-2.102H19.127c-1.398 0-2.47.367-3.217 1.1-.748.733-1.121 1.8-1.121 3.2V44.98c0 1.4.373 2.47 1.12 3.209.748.738 1.82 1.108 3.218 1.108h30.072zM22.814 40.76c.575 0 1.07-.21 1.487-.631.417-.422.626-.928.626-1.519 0-.58-.209-1.08-.626-1.501-.417-.422-.912-.632-1.487-.632-.584 0-1.085.21-1.502.632-.417.42-.626.922-.626 1.501 0 .591.209 1.097.626 1.519.417.42.918.631 1.502.631zm6.515 0c.585 0 1.083-.21 1.495-.631.412-.422.617-.928.617-1.519 0-.58-.205-1.08-.617-1.501-.412-.422-.91-.632-1.495-.632-.585 0-1.083.21-1.494.632-.412.42-.618.922-.618 1.501 0 .591.206 1.097.618 1.519.411.42.91.631 1.494.631zm6.531 0c.585 0 1.083-.21 1.495-.631.412-.422.617-.928.617-1.519 0-.58-.205-1.08-.617-1.501-.412-.422-.91-.632-1.495-.632-.595 0-1.102.21-1.519.632-.417.42-.625.922-.625 1.501 0 .591.208 1.097.625 1.519.417.42.924.631 1.52.631z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentNull);
export default __webpack_public_path__ + "static/media/content_null.e0b8406e6d65dd8afce446b08275a01f.svg";
export { ForwardRef as ReactComponent };